import type { ResourceBlock } from '@domain/schemas/contract.schema';

export const AMENDED_POSTFIX = '(amended)';

/** Appends the system-managed `(amended)` postfix. Empty names are returned untouched. */
export const withAmendedPostfix = (name: string | undefined, isAmended: boolean): string => {
  if (!name || !isAmended) {
    return name ?? '';
  }

  return `${name} ${AMENDED_POSTFIX}`;
};

/**
 * Display name for a block: the stored name, postfixed with `(amended)` when the block instance has
 * been marked as amended on its contract. Callers keep their own fallback copy for empty names.
 */
export const getBlockDisplayName = ({ name, amended_at }: Pick<ResourceBlock, 'name' | 'amended_at'>): string =>
  withAmendedPostfix(name, Boolean(amended_at));
